import { useMemo } from "react";
import { Cell, RowData, flexRender } from "@tanstack/react-table";
import { Text } from "@radix-ui/themes";
import * as ShadcnTable from "@/v2/shared/shadcn-ui/table";
import { TextWithTooltip } from "@/components/shared/tooltip";

type TableCellProps<RowDataType extends RowData> = Cell<RowDataType, unknown>;

export function TableCell<RowDataType extends RowData>({
  id,
  column,
  getContext,
}: TableCellProps<RowDataType>) {
  const align = useMemo(() => {
    return (column.columnDef.meta as { align?: string })?.align ?? "left";
  }, [column.columnDef.meta]);

  const hasTooltip = useMemo(() => {
    return (
      (column.columnDef.meta as { cellTooltip?: boolean })?.cellTooltip ?? true
    );
  }, [column.columnDef.meta]);

  return (
    <ShadcnTable.TableCell
      key={id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: align,
        width: column.getSize(),
      }}
    >
      {hasTooltip ? (
        <TextWithTooltip size="1" color="gray" highContrast truncate>
          {flexRender(column.columnDef.cell, getContext())}
        </TextWithTooltip>
      ) : (
        <Text size="1" color="gray" highContrast truncate>
          {flexRender(column.columnDef.cell, getContext())}
        </Text>
      )}
    </ShadcnTable.TableCell>
  );
}
